<template>
    <div>
        <page-header title="SMS Inbox" />
        <b-container>
            <b-card v-for="message in history" class="mt-3" :key="message.id">
                <p>{{message.outbound ? 'Outbound' : 'Inbound'}} Message</p>
                <p>{{message.message}}</p>
                <p>{{message.createdAt | moment('from')}}</p>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import $twilio from '@/services/twilio';
import PageHeader from '@/components/global/PageHeader';
import { ListSMSInbox } from '@/gql/members/SMS.gql';

export default {
    components: {
        PageHeader
    },
    apollo: {
        history :{
            query: ListSMSInbox,
            variables: {
                number: $twilio.number
            }
        }
    },
}
</script>
